import React from "react";

type Props = {
  member: {
    name: string;
    name_en: string;
    position: string;
    certification: string;
    career: any;
    thumbnail: string;
  };
};

export const Member = (props: Props) => {
  return (
    <div className="member-item">
      <div className="thumb">
        <img
          src={props.member.thumbnail}
          alt={props.member.name}
          style={{ pointerEvents: "none" }}
        />
      </div>
      <div className="detail">
        {/* <p className="position">
          <img src="../images/consultant/slash.png" alt="" />
          {props.member.position}
        </p> */}
        <div className="name">
          <img src="../images/consultant/slash.png" alt="" />
          <h3>
            <strong>{props.member.name}</strong>
            <span>{props.member.name_en}</span>
          </h3>
        </div>
        {/* <h3>
          <strong>{props.member.name}</strong>
          <span>{props.member.name_en}</span>
        </h3> */}
        {/* <div className="certification">
          <p>{"<保有資格>"}</p>
          <div className="text">
            <p>{props.member.certification}</p>
          </div>
        </div> */}
        <div className="career">
          <span>{"<経歴>"}</span>
          <br />
          <p dangerouslySetInnerHTML={{ __html: props.member.career }}></p>
        </div>
      </div>
    </div>
  );
};
